import { render } from "./DbaFormContainer.vue?vue&type=template&id=2d283a44"
import script from "./DbaFormContainer.vue?vue&type=script&lang=js"
export * from "./DbaFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__